import app from 'flarum/forum/app';
import { KeyValueGambit } from 'flarum/common/query/IGambit';
export default class SsoGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('fof-oauth.lib.gambits.sso.key', {}, true);
  }
  hint() {
    return app.translator.trans('fof-oauth.lib.gambits.sso.hint', {}, true);
  }
  filterKey() {
    return 'sso';
  }
  enabled() {
    return !!app.forum.attribute('fofOauthModerate');
  }
}
flarum.reg.add('fof-oauth', 'forum/query/SsoGambit', SsoGambit);